import { useAppDispatch, useAppSelector } from 'app/hooks'
import Card from 'components/Card'
import {
  paymentMethodsListSelector,
  selectedPaymentMethodIdSelector,
} from 'features/paymentMethods/selectors'
import { selectedPaymentMethodActions } from 'features/paymentMethods/slice'
import { PaymentMethodCardLi, PaymentMethodCardsUl } from './styles'

interface PaymentMethodsCardsListProps {
  isFullPage?: boolean
}

function PaymentMethodsCardsList(props: PaymentMethodsCardsListProps) {
  const dispatch = useAppDispatch()
  const paymentMethods = useAppSelector(paymentMethodsListSelector.data)
  const selectedPaymentMethod = useAppSelector(selectedPaymentMethodIdSelector)

  return (
    <PaymentMethodCardsUl $isFullPage={props.isFullPage}>
      {paymentMethods?.map((paymentMethod) => (
        <PaymentMethodCardLi
          key={paymentMethod.id}
          $isFullPage={props.isFullPage}
        >
          <Card
            paymentMethod={paymentMethod}
            onSelect={(id) =>
              dispatch(selectedPaymentMethodActions.selectPaymentMethod(id))
            }
            isSelected={selectedPaymentMethod === paymentMethod.id}
            isSingleMethod={paymentMethods.length === 1}
          />
        </PaymentMethodCardLi>
      ))}
    </PaymentMethodCardsUl>
  )
}

export default PaymentMethodsCardsList
